<template>
    <div class="introduction">
        <Header></Header>
        <div class="introduction__landing">
            <div class="introduction__landing--left">
                <img src="@/assets/images/banners/governance_intro.png" class="background" alt="">
                <div class="section-title">
                    <h1>{{introduction.title}}</h1>
                </div>
            </div>
            <div class="introduction__landing--right">
                <!-- ayyan -->
                <div class="scrollWrapper">
                    <scrollbar class="scrollSettings">
                        <div class="wrapper_container">
                            <div class="main_heading">
                                <h2>{{introduction.title2}}</h2>
                            </div>
                            <p v-for="(intro,index) in introduction.introduction" :key="index">
                                {{intro}}
                            </p>
                                
                        </div>
                    </scrollbar>
                </div>
                <a href="#" @click.prevent.stop="toggleRules" class="explore">
                    {{$t('labels.exploreMore')}}
                    <svg fill="currentColor"  xmlns="http://www.w3.org/2000/svg" width="26.176" height="12.679" viewBox="0 0 26.176 12.679">
                        <use xlink:href="#right-arrow"></use>
                    </svg>
                </a>
            </div>
        </div>
        <introductionRules :rules="this.introduction.rules" ref="rules"></introductionRules>
    </div>
</template>

<script>


import animation from '@/mixin/animation.js';
import introductionRules from '@/components/governance/introductionRules.vue';
import introduction from '@/components/governance/json/introduction'
    export default {
        data(){
            return{
                introduction: introduction,
                scrollSettings: {
                    maxHeight: 100,
                    horizontal:false,
                }
                
            }
        },
        components:{
            introductionRules
        },
        created(){
            this.$i18n.locale=="en" ? 
            this.introduction = this.introduction.en :
            this.introduction = this.introduction.ar;
        },
        mounted(){
            this.titleAnimation();
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
            window.addEventListener('resize', () => {
            // We execute the same script as before
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            });
        },
        mixins: [animation],
        methods:{
            toggleRules: function(e){
                document.querySelector(".introduction__rules").classList.toggle("active");
                this.$refs.rules.animateFirstSlide();
                this.$refs.rules.slideDown();
            },
        }
    }
</script>
<style lang="scss">
[data-page='governance']{
    height: 100vh;
    overflow: hidden;
    .reportTitle{
        color:#000;
    }
    ::-webkit-scrollbar {
    display: none;
    }
    .scrollSettings{
        scrollbar-color: transparent transparent;
    }
    ::-moz-scrollbar {
    scrollbar-color: transparent transparent;
    display: none !important;
    -ms-overflow-style: none; /* IE 11 */
    scrollbar-width: none; /* Firefox 64 */
    }
}
</style>
<style lang="scss" scoped>
.introduction{
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    @media screen and (max-width:767px){
        /deep/{
            .table-wrapper.big{
                overflow-x: scroll;
                >div{
                    width:800px;
                }
                .__view{
                    min-width:auto !important;
                    width:100% !important;
                }
            }
        }
    }
    &__landing{
        height: 100%;
        @include flex();
        align-items: flex-start;
        &--left{
            height: 100%;
            flex: 0 0 65%;
            max-width: 65%;
            position: relative;
            overflow: hidden;
            &:after{
                position: absolute;
                content:"";
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.4);
                left: 0;
                top:0;
                z-index: -1;
            }
            .background{
                object-fit: cover;
                object-position: left bottom;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                z-index: -1;
            }
            .section-title{
                @include flex(center,center);
                height: 100%;
            }
            h1{
                font-size: rem(90px);
                color:#fff;
                font-weight: 800;
                text-transform: uppercase;
                @media screen and (max-width:991px){
                    font-size:rem(60px);
                }
                @media screen and (max-width:767px){
                    font-size:rem(40px);
                }
            }
            @media screen and (max-width:991px){
                flex:0 0 56%;
                max-width:56%;
            }
        }
        &--right{
            flex: 1;
            background:#fff;
            // display: flex;
            // justify-content: center;
            // flex-direction: column;
            // height: 100%;
            padding-right: rem(40px);
            padding-left: rem(45px);
            height: 100%;
            .scrollWrapper{
                height: calc(100vh - 190px);
                margin-top: rem(80px);
                @media screen and (max-width: 767px){
                    height: auto;
                }
                .wrapper_container{
                    padding-top: rem(30px);
                    padding-right: rem(15px);
                    @media screen and (max-width:767px){
                        padding-top:0;
                    }
                    .main_heading{
                        margin-top: 0px;
                        h2{
                            font-size: rem(40px);
                            font-weight: 800;
                            color: #484B4A;
                            margin-bottom: 35px;
                            @media screen and (max-width:767px){
                                font-size: rem(28px);
                                margin-bottom: 20px;
                            }
                        }
                        
                       
                    }
                    p{
                        color: #464646;
                        font-size: rem(18px);
                        font-weight: 700;
                        line-height: 1.3;
                    }
                    
                }
                @media screen and (max-width:767px){
                    margin-top:rem(20px);
                }
            }
            .explore{
                text-decoration: none;
                border: 4px solid #707070;
                padding: 15px 40px;
                color: #484B4A;
                text-transform: uppercase;
                display: inline-block;
                margin-top: rem(25px);
                font-size: rem(16px);
                font-weight: 700;
                transition: all 0.6s ease;
                svg{
                    position: relative;
                    top: -1px;
                    right: -3px;
                    transition: all 0.6s ease;
                }
                &:hover{
                    border-color: #535353;
                    svg{
                        transition: all 0.6s ease;
                        right: -8px;
                    }
                    
                }
            }
            @media screen and (max-width:991px){
                padding:0 rem(20px);
                .explore{
                    padding: 15px 20px;
                    border-width:3px;
                }
            }
            @media screen and (max-width:575px){
                .explore{
                    margin-bottom:rem(50px);
                }
            }
        }
        @media screen and(max-width:767px){
            flex-direction:column;
            display:block;
            &--left{
                flex:0 0 100%;
                max-width:100%;
                height:400px;
                
            }
            &--right{
                height:auto;
                padding-top:rem(20px);
                padding-bottom:rem(100px);
            }
        }
    }
    
}

// arabic
[lang="ar"] {
    .introduction{
        /deep/{
           .arrow{
                right: 12px;
                left:0;
           }
           .rules__item a svg{
               transform: rotate(-180deg);
           }
        }
        &__landing{
            
            &--left{
                
                .background{
                    
                    right: 0; left: auto;
                    
                }
                
            }
            &--right{
                
                padding-left: rem(40px);
                padding-right: rem(45px);
                
                .scrollWrapper{
                    
                    .wrapper_container{
                        padding-left: rem(15px);
                        padding-right: 0;
                    }
                }
                .explore{
                    padding-left: 40px; padding-right: 40px;
                    
                    svg{
                        
                        left: -3px; 
                        right: auto;
                        transform: rotate(180deg);
                    }
                    &:hover{
                        svg{
                            left: -8px; 
                            right: auto;
                        }
                        
                    }
                }
                @media screen and (max-width:991px){
                    
                    padding-left: 20px; padding-right: 20px;
                    .explore{
                        padding-left: 20px; padding-right: 20px;
                    }
                }
            }
            
        }
        
    }
}

</style>